import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const TEXTURE_IMG =
  "https://images.unsplash.com/photo-1686806372785-fcfe9efa9b70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxjYWxtJTIwd2FybSUyMGJlaWdlJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODgwMTc4OTh8MA&ixlib=rb-4.1.0&q=85&auto=format&fit=crop&w=2000";

export default function Unterschied() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-14%", "14%"]);

  return (
    <section ref={ref} data-testid="unterschied-section" className="relative overflow-hidden px-6 md:px-14 py-20 md:py-28">
      <motion.div className="absolute inset-0" style={{ y }}>
        <img src={TEXTURE_IMG} alt="" aria-hidden="true" className="h-[130%] w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-shell/70" />
      </motion.div>

      <div className="relative z-10 max-w-3xl mx-auto">
        <Reveal>
          <p className="text-xs md:text-sm font-medium uppercase tracking-[0.32em] text-bronze mb-6">
            Was ist der Unterschied?
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-serif tracking-tight text-2xl md:text-4xl leading-tight text-espresso">
            Wir entspannen nicht nur.<br />Wir arbeiten gezielt mit deinem Thema.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-10 text-base md:text-lg font-light leading-relaxed text-taupe">
            Eine klassische Meditation kann dir helfen, zur Ruhe zu kommen, Gedanken
            wahrzunehmen und im gegenwärtigen Moment anzukommen.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Bei dieser Hypnomeditation richte ich deine Aufmerksamkeit gezielt auf
            das Loslassen. Mit meiner Stimme, hypnotischen Suggestionen und inneren
            Bildern begleite ich dich durch diesen Prozess.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Du musst nicht vergessen, was passiert ist. Du musst nichts schönreden.
            Und dir muss auch nichts plötzlich egal sein.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-12 md:mt-16 text-center">
            <span className="inline-block h-px w-16 bg-gold mb-10" aria-hidden="true" />
            <p data-testid="unterschied-highlight" className="font-serif italic tracking-tight text-xl sm:text-2xl md:text-3xl leading-[1.35] text-espresso">
              Du kannst nicht verändern, was passiert ist.<br />
              Aber du kannst verändern,<br />
              wie dein Inneres heute darauf reagiert.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
